module.exports = __webpack_public_path__ + "static/media/b1.ffae12bc.jpg";